import authStore from './auth';
import businessStore from './business';
import merchantAccountStore from './merchantAccount';
import pageStore from './page';
import storesStore from './stores';
import usersStore from './users';

const models = {
  bussiness: businessStore,
  merchantAccount: merchantAccountStore,
  auth: authStore,
  stores: storesStore,
  users: usersStore,
  page: pageStore,
};

export default models;
